import { routes } from '~/shared/constants/routes';
import { type ProcessingMode } from '../model';

export const getProcessingModeByPathname = (pathname: string): ProcessingMode | null => {
    if (pathname.startsWith(routes.payout)) {
        return 'payout';
    }

    if (pathname.startsWith(routes.payin)) {
        return 'payin';
    }

    return null;
};
